'use client';
import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { DispatchCursor } from 'haspr-cursor';
import { theme } from '@/styles/theme/index.jsx';

const Button = ({
					onSubmit, // Form submission handler
					onClick, // Click event handler
					text, // Text to display on the button
					src, // Link URL
					img, // Background image for the button
					hoverImg, // Hover state background image
					fontSize, // Font size
					fontWeight, // Font weight
					color, // Text color
					hoverColor, // Text color on hover
					letterSpacing, // Letter spacing
					lineheight, // Line height
					margin, // Margin around the button
					marginSm, // Margin for small devices
					padding, // Padding inside the button
					background, // Button background color
					hoverbackground, // Hover state background color
					borderradius, // Border radius
					border, // Border styles
					bordercolor, // Border color
					width, // Button width
					height, // Button height
					target, // Target attribute for links
					className, // Additional classes
					transition, // Transition effect duration and timing
					boxShadow, // Shadow styles
					zIndex, // Z-index
					borderHoverColor,
				}) => {
	const dispatch = DispatchCursor();

	return (
		<StyledBtn
			onClick={onClick}
			onSubmit={onSubmit}
			className={`${className ? className : 'fade-up'} dc-btn`}
			fontSize={fontSize}
			fontWeight={fontWeight}
			color={color}
			background={background}
			hoverColor={hoverColor}
			hoverbackground={hoverbackground}
			lineheight={lineheight}
			letterSpacing={letterSpacing}
			margin={margin}
			marginSm={marginSm}
			padding={padding}
			border={border}
			borderradius={borderradius}
			bordercolor={bordercolor}
			width={width}
			height={height}
			img={img}
			hoverImg={hoverImg}
			zIndex={zIndex}
			boxShadow={boxShadow}
			transition={transition}
			borderHoverColor={borderHoverColor}
			>
			{src && typeof src === 'string' ? (
				src.startsWith('http') || src.startsWith('www') ? (
					<a href={src} target="_blank" rel="noopener noreferrer">
            <span>
              {text}
            </span>
					</a>
				) : (
					<Link prefetch={true} href={src || '/'} className="js-lookforward" data-transition-enter="slideup" data-transition-leave="slidedown">
            <span>
              {text}

            </span>
					</Link>
				)
			) : (
				<a target={target || '_self'}>
          <span>
            {text}

          </span>
				</a>
			)}
		</StyledBtn>
	);
};

const StyledBtn = styled.div`
    &.dc-btn {
        margin: ${props => props.margin || '0'};
        width: ${props => props.width || 'fit-content'};
        height: ${props => props.height || '48px'};
        cursor: pointer;
        position: relative;
        border: ${props => props.border || 'none'};
        border-radius: ${props => props.borderradius || '0'};
        box-shadow: ${props => props.boxShadow || 'none'};
        z-index: ${props => props.zIndex || 0};
        transition: ${props => props.transition || theme.transition};
        overflow: hidden;
        border-color: ${props => props.bordercolor || theme.colors.secondaryGreen};
        &:hover {
            border-color: ${props => props.borderHoverColor || theme.colors.hover};
        }
        a {
            display: flex;
            width: 100%;
            align-items: center;
            height: ${props => props.height || '48px'};
            justify-content: center;
            font-size: ${props => props.fontSize || '1rem'};
            font-weight: ${props => props.fontWeight || '400'};
            color: ${props => props.color || theme.colors.white};
            letter-spacing: ${props => props.letterSpacing || '-0.05em'};
            line-height: ${props => props.lineheight || '1'};
            padding: ${props => props.padding || '0 30px 3px'};
            position: relative;
            overflow: hidden;
            background: ${props => props.background || theme.colors.secondaryGreen};
            transition: ${props => props.transition || theme.transition};

            span {
                transition: ${theme.transition};
                position: relative;
                z-index: 2;
                color: ${props => props.color || theme.colors.white};
                display: flex;
                align-items: center;
                justify-content: center;
                transition: ${theme.transition};

            }

            &:before {
                border-radius: ${props => props.borderradius || '0'};
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                height: 100%;
                width: 100%;
                opacity: 0;
                background: ${props => props.hoverbackground || theme.colors.hover};
                transition: ${props => props.transition || theme.transition};
                z-index: 1;
                overflow: hidden;
				transform: scale(0);
            }

            &:hover {
                background: ${props => props.hoverbackground || theme.colors.hover};
                span {
                    color: ${props => props.hoverColor || theme.colors.white};
                }

                &:before {
                    opacity: 1;
                    transform: scale(1);
					
                }

            }
        }

    }
`;

export default Button;
